import { CSSProperties, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useFullscreenElement } from 'src/providers/FullscreenProvider/FullscreenProvider';
import { getAgentState } from 'src/store/agent/selectors';

const paddings = '32px';

export const useMapStyle = (): [boolean, CSSProperties] => {
  const { fullscreen } = useFullscreenElement();
  const { height, headerHeight } = useSelector(getAgentState);

  const result = useMemo((): [boolean, CSSProperties] => {
    let resultHeight = '100%';
    let fixed = false;
    if (height <= 600) {
      fixed = true;
      resultHeight = fullscreen
        ? `calc(100dvh - ${paddings})`
        : `calc(100dvh - ${headerHeight}px - ${paddings})`;
    }

    return [fixed, { height: resultHeight }];
  }, [fullscreen, headerHeight, height]);

  return result;
};
